import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "./styles/globals.css";

// i18n 초기화 (앱 부트스트랩 최초 시점에 i18next.init 실행)
import "@/lib/i18n";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { installPreloadReload } from "@/lib/preloadReload";

import { App } from "./App";

// 배포 후 옛 화면 파일 로딩 실패 시 1회 자동 새로고침(오류 화면 대신 최신 버전 수신).
installPreloadReload();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
